import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default () => {
  const parallaxItems = gsap.utils.toArray("[data-parallax]");

  parallaxItems.forEach((panel, i) => {
    // Check if the current panel is the last one
    const isLastPanel = i === parallaxItems.length - 1;

    ScrollTrigger.create({
      trigger: panel,
      start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",
      end: 'bottom top',
      pin: true,
      pinSpacing: false,
      // If the current panel is not the last one, pin it; otherwise, don't pin
      pin: !isLastPanel,
      onToggle: () => {
        if(panel.dataset.activeIndex){
          panel.closest('section').style.setProperty("--active-index", panel.dataset.activeIndex);
        }  
      }
    });
  });
}